module.exports = __webpack_public_path__ + "img/ambitions.e2b50f20.svg";